import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { Auth } from 'aws-amplify';
import { APIService, CreateTabProfileInput, TabType, ModelStringKeyConditionInput, CreateUserDataInput, CreateUserDataMutation,
  ModelCountyRecordFilterInput, UpdateCountyRecordInput, UpdateTabProfileInput, ModelTabProfileFilterInput, UpdateTabProfileMutation,
  ListCountyRecordsQuery, UpdateCountyRecordMutation, UpdateUserDataInput, UpdateUserDataMutation, TabProfile, CreateTabProfileMutation, TableProfileInput, NoteProfileInput, DeleteTabProfileInput } from 'src/app/services/API.service';
import { MatTableDataSource } from '@angular/material/table';
import { Tab } from 'src/app/models/tab';
import { CountyRecord } from '../models/countyRecord';
import { User } from 'src/app/models/user';
import { FormGroup } from '@angular/forms';


@Injectable({
  providedIn: 'root'
})
export class DataService {
  tabs: Tab[] = [];
  user: User;
  refresh: boolean;

  constructor(private api: APIService) { }

  GetUser(): Observable<User> {
    let user: User;

    return new Observable(obs => {
      from(
        Auth.currentUserInfo()
        .then(n => {
          user = new User(n);
          user.loggedIn = true;

          this.GetUserGroups()
          .subscribe(g => {
            user.groups = g;

            user.admin = g.includes('admin');

            this.user = user;
            
            obs.next(this.user);
          });
        })
      );
    });
  }

  GetUserGroups(): Observable<string[]> {
    let groups: string[] = [];

    return new Observable(obs => {
      from(
        Auth.currentAuthenticatedUser()
      .then(n => {
        groups = n.signInUserSession.accessToken.payload['cognito:groups'];
        obs.next(groups);
      })
      );
    });
  }

  DeleteRecord(data: CountyRecord, index: number) {
    const update: UpdateCountyRecordInput = {
      pKey: data.pKey,
      sKey: data.sKey,
      id: data.id
    };

    return new Observable(obs => {
      data.ExcludeList.push(this.user.id);

      update.Exclude = [... new Set(data.ExcludeList)];

      this.UpdateRec(update).subscribe(n => {
        const i = this.tabs[index].data.data.findIndex(n => n.id === data.id);
        this.tabs[index].data.data.splice(i, 1);

        const dt = this.tabs[index].data.data.filter(n => n.id !== data.id);
        this.tabs[index].data.data = dt;

        obs.next(n);
      });
    });
  }

  UpdateRecords(data: CountyRecord[], index: number): Observable<boolean> {

    return new Observable(obs => {
      data.forEach(n => {
        if (n.UpdateList) {
          if (n.UpdateList.includes('note')) {

            if (n.UserData.id) {
              this.UpdateUserData(n.UserData.updates())
              .subscribe(n => {});
            } else {
              const txt = n.UserData.Note.get('TextArea').value;
              const newData: CreateUserDataInput = {
                pKey: n.pKey,
                sKey: n.sKey,
                delete: n.UserData.delete,
                viewed: n.UserData.viewed,
                Note: [{
                  Seq: n.UserData.Note.get('Seq').value,
                  Selected: n.UserData.Note.get('Selected').value,
                  TextArea: (typeof txt === 'string' ? txt : ' ')
                }]
              };

              this.NewUserData(newData)
              .subscribe(n => {});
            }
          }

          if (n.UpdateList.includes('exclude')) {
            let k = [... new Set(this.tabs[index].Exclude)];

            k.push(n.FromParties[0]);

            k = [... new Set(k)];

            this.UpdateExclusions(k, index);

            this.filterData(n.FromParties[0], index);

          }
        }
      });

      obs.next(true);
    });
  }

  filterData(key: string, index: number) {

    const dt = this.tabs[index].data.data.filter(n => {
      return n.FromParties[0] !== key;
    });

    this.tabs[index].data.data = dt;
  }

  UpdateExclusions(keys: string[], index: number) {

    const update: UpdateTabProfileInput = {
      id: this.tabs[index].id,
      ExclusionList: keys
    };

    this.tabs[index].Exclude = keys;

    this.UpdateTabProfile(update);

  }

  GetTabs(): Observable<Tab[]> {
    const tabs: Tab[] = [];
    const filter: ModelTabProfileFilterInput = {};

    filter.UserID = {
      eq: this.user.email
    };

    return new Observable(obs => {
      from(this.api.ListTabProfiles(filter))
      .subscribe(n => {
        n.items.forEach(x => {
          tabs.push(new Tab(x));
        });

        this.tabs = tabs;

        obs.next(this.tabs);
      });
    });
  }

  GetTabsByUser(id: string): Observable<TabProfile[]> {
    const tabs: TabProfile[] = [];
    const filter: ModelTabProfileFilterInput = {};

    filter.UserID = {
      eq: id
    };

    return new Observable(obs => {
      from(this.api.ListTabProfiles(filter))
      .subscribe(n => {
        n.items.forEach(x => {
          tabs.push(x);
        });

        obs.next(tabs);
      });
    });    
  }

  GetDefaultTabs(): Observable<TabProfile[]> {
    const tabs: TabProfile[] = [];
    const filter: ModelTabProfileFilterInput = {};

    filter.Type = {
      eq: TabType.Default
    }

    return new Observable(obs => {
      from(this.api.ListTabProfiles(filter))
      .subscribe(n => {
        n.items.forEach(x => {
          tabs.push(x);
        });

        obs.next(tabs);
      });
    }); 
  }

  GetAllTabs(): Observable<TabProfile[]> {
    const tabs: TabProfile[] = [];
    const filter: ModelTabProfileFilterInput = {};

    filter.Type = {
      ne: null
    }

    return new Observable(obs => {
      from(this.api.ListTabProfiles(filter))
      .subscribe(n => {
        n.items.forEach(x => {
          tabs.push(x);
        });

        obs.next(tabs);
      });
    }); 
  }

  UpdateRec(recInput: UpdateCountyRecordInput): Observable<UpdateCountyRecordMutation> {

    return new Observable(obs => {
      from(this.api.UpdateCountyRecord(recInput))
      .subscribe(n => {
        obs.next(n);
      });
    });
  }

  AddUpdateTab(tab: FormGroup) {
    var table = tab.get('Table').value;
    var note = tab.get('Note').value;

    var rec = {
      id: null,
      Title: tab.get('Title').value,
      UserID: tab.get('UserID').value,
      Type: tab.get('Type').value,
      RecordKey: tab.get('RecordKey').value,
      ExclusionList: tab.get('ExclusionList').value,
      Table: {
        PageSizeOptions: table['PageSizeOptions'],
        Columns: table['Columns']
      },
      Note: {
        NotesTitle: note['NotesTitle'],
        DropTitle: note['DropTitle'],
        DropDownEntries: note['DropDownEntries']
      }
    };

    if (tab.get('Created').value) {
      rec.id = tab.get('id').value;
      var update: UpdateTabProfileInput = rec;

      this.UpdateTabProfile(update);

    } else {
      var newRec: CreateTabProfileInput = rec;
      
      this.NewTabProfile(newRec);

    }

  }

  DeleteTab(key: string) {
    var del: DeleteTabProfileInput = {
      id: key
    };

    this.api.DeleteTabProfile(del);
  }

  UpdateTabProfile(input: UpdateTabProfileInput): Observable<UpdateTabProfileMutation> {
    return from(this.api.UpdateTabProfile(input));
  }

  NewTabProfile(input: CreateTabProfileInput): Observable<CreateTabProfileMutation> {
    return from(this.api.CreateTabProfile(input));
  }

  AddTab() {
    const n: CreateTabProfileInput = {
      Title: 'Collier County Judgements'
    };

    n.UserID = this.user.email;
    n.Type = TabType.Standard;
    n.RecordKey = 'FL-Collier-Judgement';
    n.ExclusionList = ['bank', 'credit union'];
    n.Table = {
      Columns: [{
        Field: 'select',
        HeaderTxt: 'Select'
      }, {
        Field: 'RecordNumber',
        HeaderTxt: 'Instrument'
      }, {
        Field: 'RecordDateDisp',
        HeaderTxt: 'Date'
      }, {
        Field: 'Status',
        HeaderTxt: 'Status'
      }, {
        Field: 'Score',
        HeaderTxt: 'Score'
      }, {
        Field: 'FromParties',
        HeaderTxt: 'From'
      }, {
        Field: 'ToParties',
        HeaderTxt: 'To'
      }, {
        Field: 'UpdatedDisp',
        HeaderTxt: 'Updated'
      }],
      PageSizeOptions: [10, 25, 50, 100]
    };

    n.Note = {
      DropTitle: 'Property Status',
      NotesTitle: 'Property Notes',
      DropDownEntries: [{
        seq: 0,
        text: 'Viewed',
        value: 1
      },
      {
        seq: 1,
        text: 'Important',
        value: 2
      },
      {
        seq: 2,
        text: 'Researching',
        value: 3
      },
      {
        seq: 3,
        text: 'Completed',
        value: 4
      },
      {
        seq: 4,
        text: 'Ignore',
        value: 5
      }]
    };

    this.api.CreateTabProfile(n);
  }

  NewUserData(data: CreateUserDataInput): Observable<CreateUserDataMutation> {

    return new Observable(obs => {
      from(this.api.CreateUserData(data))
      .subscribe(n => obs.next(n));
    });
  }

  UpdateUserData(data: UpdateUserDataInput): Observable<UpdateUserDataMutation> {

    return new Observable(obs => {
      from(this.api.UpdateUserData(data))
      .subscribe(n => obs.next(n));
    });
  }

  FilterRecs(keys: string[], data: CountyRecord[]): CountyRecord[] {
    let ret: CountyRecord[] = data;

    keys.forEach(n => {
      ret = ret.filter(x => {
        const srch = x.FromParties.join(',');

        return !srch.includes(n.toUpperCase());
      });
    });

    return ret;
  }

  GetRecords(dates: string[], index: number) {
    const pkey = this.tabs[index].RecordKey;
    const skey: ModelStringKeyConditionInput = {};
    const filter: ModelCountyRecordFilterInput = {};

    if (this.tabs[index].downloading) {
      return;
    }

    skey.between = dates;

    filter.Exclude = {
      notContains: this.user.id
    };

    this.tabs[index].data = new MatTableDataSource<CountyRecord>([]);

    this.tabs[index].downloading = true;

    this.LoadData(pkey, skey, filter, index, '');
  }

  LoadData(
    pkey: string,
    skey: ModelStringKeyConditionInput,
    filter: ModelCountyRecordFilterInput,
    index: number,
    token: string) {

    this.GetAllRecords(pkey, skey, filter, index, token)
    .subscribe(obs => {
      let data = obs.items.map(x => new CountyRecord(x));

      if (this.tabs[index].Exclude && this.tabs[index].Exclude.length > 0) {
        data = this.FilterRecs(this.tabs[index].Exclude, data);
      }

      data.forEach(x => {
        x.addProfile(this.tabs[index].NoteProfile);
      });

      this.tabs[index].data.data = this.tabs[index].data.data.concat(data);

      if (obs.nextToken) {
        this.LoadData(pkey, skey, filter, index, obs.nextToken);
      } else {
        this.tabs[index].downloading = false;
      }
    });
  }

  GetAllRecords(pkey: string,
                skey: ModelStringKeyConditionInput,
                filter: ModelCountyRecordFilterInput,
                index: number,
                next?: string): Observable<ListCountyRecordsQuery> {

    return new Observable(obs => {
      from(
        this.api.ListCountyRecords(pkey, skey, filter, 2000, next)
      ).subscribe(n => {

        obs.next(n);

      }, e => {
        this.tabs[index].downloading = false;
        this.tabs[index].downloadErr = true;
      });
    });
  }
}

